<template>
  <div class="dynamicScroll">
    <span class="modal-body-text" v-if="!this.data || this.data.length <= 0"
      >Please select some activities to add!</span
    ><br /><br />
    <span class="modal-body-text" v-if="this.data && this.data.length > 0"
      >You are about to add <b>{{ numberOfActivities }}</b> following activities
      to program:</span
    ><br />
    <span v-bind:key="item.id" v-for="item in activities"
      >+ {{ item.title }};<br
    /></span>
    <br />
    <span class="modal-body-text">Are you sure you want to continue?</span>
    <br />
  </div>
</template>

<script>
export default {
  name: "bulk-add-activities-modal",
  props: {
    data: null
  },
  computed: {
    activities() {
      return this.data || [];
    },
    numberOfActivities() {
      if (this.data && this.data.length) {
        return this.data.length;
      }
      return 0;
    }
  }
};
</script>
<style scoped>
.dynamicScroll {
  overflow-y: auto;
  max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/BulkAddActivities.vue